import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";

export async function sendGuideEmail(email: string): Promise<boolean> {
    try {
        const res = await instance.post(`/users/guide-email/google-login`, { 
            email: email
        });
        return res.data;
    } catch (error: any) {
        Sentry.captureException(error);
        return false;
    }
}